import { useHead, useSeoMeta } from "@unhead/react";
import { useTranslation } from "react-i18next";
import { LogoText } from "../../../assets/icons";
import { useIsMobile } from "../../../hooks/customDeviceDetect";
import { cn } from "../../../util/classNameConstructor";
import Button from "../../core/button/Button";

const Imprint = ({ handleNavigateBack, project }) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  useSeoMeta({
    title: project?.title
      ? `${project.title} – ${t("imprint:title")}`
      : t("imprint:title"),
    themeColor: project?.color,
  });

  // Do not index legal pages by search engines
  useHead({
    meta: [{ name: "robots", content: "noindex, follow" }],
  });

  return (
    <div className="h-screen w-screen overflow-y-auto">
      <div className="ml-12 mt-7">
        <LogoText transform="scale(2)" />
      </div>
      <div className="mx-auto mt-48 max-w-3xl px-4 py-8">
        <Button
          variant="outline"
          leadingIcon="arrow-left-md"
          text={t("global:back")}
          onClick={handleNavigateBack}
        />
        <h1
          className={cn(
            "my-6 font-black",
            isMobile ? "heading-2xl" : "heading-5xl",
          )}
        >
          {t("imprint:title")}
        </h1>

        <h2 className="heading-xl mb-4">{t("imprint:section_1_title")}</h2>
        <p className="body-md-bold mb-1">{t("imprint:company_name")}</p>
        <p className="body-md mb-6">{t("imprint:address")}</p>

        <h2 className="heading-xl mb-4">{t("imprint:contact_title")}</h2>
        <p className="body-md mb-1">{t("imprint:phone")}</p>
        <p className="body-md mb-6">{t("imprint:email")}</p>

        <h2 className="heading-xl mb-4">{t("imprint:section_2_title")}</h2>
        <p className="body-md mb-6">{t("imprint:section_2_content")}</p>

        <h2 className="heading-xl mb-4">{t("imprint:section_3_title")}</h2>
        <p className="body-md mb-6">{t("imprint:section_3_content")}</p>

        <h2 className="heading-xl mb-4">{t("imprint:section_4_title")}</h2>
        <p className="body-md mb-6">{t("imprint:section_4_content")}</p>
      </div>
    </div>
  );
};

export default Imprint;
